import apiFetch from '../apiFetch'

export default function (token, comercialCode) {
  return apiFetch({ endPoint: `vehicle/destinationCombo/${comercialCode}`, method: 'GET', body: null, token: token })
}
